import permissionService from './permissionService'

export { PermissionService } from './permissionService'

export default permissionService
